module.exports = __webpack_public_path__ + "static/media/easy-access.d44d76da.svg";